import { Paper } from '@mui/material';
import styled from '@emotion/styled';

export const SlidePaper = styled(Paper)`
  padding: ${props => props.theme.spacing(2)};
  text-align: center;
  height: 100%;
  margin-top: ${props => props.theme.spacing(1)};
`;
